import { createRouter, createWebHistory } from '@ionic/vue-router';
import { useStore } from 'vuex';
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'root',
    meta: {
      isAuthenticated: true,
    }
  },
  {
    path: '/intro',
    name: 'intro',
    component: function () {
      return import('@/views/introduce.vue')
    }
  },
  {
    path: '/school-code',
    name: 'school-code',
    component: function () {
      return import('@/views/auth/schoolCode.vue')
    }
  },
  {
    path: '/login',
    name: 'login',
    component: function () {
      return import('@/views/auth/login.vue')
    }
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/home.vue')
    },
  },
  {
    path: '/message',
    name: 'message',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/message.vue')
    },
  },
  {
    path: '/daily-attendance',
    name: 'daily-attendance',
    component: function () {
      return import('@/views/home/attendance/daily_attendance/attendanceClass.vue')
    },
    meta: {
      isAuthorized: true
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore();

      if (!store.state.auth.profileData) {
        await store.dispatch('auth/getProfile');
      }

      const role = store.state.auth.profileData?.role;

      if (role !== 'teacher') {
        next('/list-attendance');
      } else {
        next();
      }
    }
  },
  {
    path: '/list-attendance',
    name: 'list-attendance',
    component: function () {
      return import('@/views/home/attendance/daily_attendance/attendanceList.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/attendance-summary',
    name: 'attendance-summary',
    component: function () {
      return import('@/views/home/attendance/daily_attendance/attendanceSummary.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/subject-attendance',
    name: 'subject-attendance',
    component: function () {
      return import('@/views/home/attendance/subject_attendance/subjectList.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/subject-detail',
    name: 'subject-detail',
    component: function () {
      return import('@/views/home/attendance/subject_attendance/subjectDetail.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/subject-summary',
    name: 'subject-summary',
    component: function () {
      return import('@/views/home/attendance/subject_attendance/subjectSummary.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/subject-student-summary',
    name: 'subject-student-summary',
    component: function () {
      return import('@/views/home/attendance/subject_attendance/subjectSummaryStudent.vue')
    },
    meta: {
      isAuthorized: true
    },
  },
  {
    path: '/permission',
    name: 'permission',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/attendance/daily_attendance/permissionForm.vue')
    },
  },
  {
    path: '/permission-list',
    name: 'permission list',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/attendance/daily_attendance/permissionList.vue')
    },
  },
  {
    path: '/profile',
    name: 'profile',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/profile.vue')
    },
  },
  {
    path: '/profile-username',
    name: 'profile-username',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/changeProfile.vue')
    },
  },
  {
    path: '/profile-password',
    name: 'profile-password',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/changePassword.vue')
    },
  },
  {
    path: '/profile-language',
    name: 'profile-language',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/changeLanguage.vue')
    },
  },
  {
    path: '/profile-privacy-policy',
    name: 'profile-privacy-policy',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/privacyPolicy.vue')
    },
  },
  {
    path: '/profile-photo/:type',
    name: 'profile-photo',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/profile/changePhoto.vue')
    },
  },
  {
    path: '/recruitment-form',
    name: 'recruitment-form',
    component: function () {
      return import('@/views/home/recruitment/recruitmentForm.vue')
    },
  },
  {
    path: '/recruitment-edit-biodata',
    name: 'recruitment-edit-biodata',
    component: function () {
      return import('@/views/home/recruitment/editBiodata.vue')
    },
  },
  {
    path: '/recruitment-edit-attachment',
    name: 'recruitment-edit-attachment',
    component: function () {
      return import('@/views/home/recruitment/editAttachment.vue')
    },
  },
  {
    path: '/recruitment',
    name: 'recruitment',
    component: function () {
      return import('@/views/home/recruitment/recruitmentProgress.vue')
    },
  },
  {
    path: '/recruitment-admin',
    name: 'recruitment-admin',
    component: function () {
      return import('@/views/home/recruitment/recruitmentAdmin.vue')
    },
  },
  {
    path: '/recruitment-registrant',
    name: 'recruitment-registrant',
    component: function () {
      return import('@/views/home/recruitment/recruitmentRegistrant.vue')
    },
  },
  {
    path: '/academic-studyroom',
    name: 'academic-studyroom-list',
    component: function () {
      return import('@/views/home/academic/studyroom/studyRoomList.vue')
    },
  },
  {
    path: '/academic-studyroom/:id',
    name: 'academic-studyroom',
    component: function () {
      return import('@/views/home/academic/studyroom/studyRoom.vue')
    },
  },
  {
    path: '/academic-subject-schedule',
    name: 'academic-subject-schedule',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/subject_schedule/subjectSchedule.vue')
    },
  },
  {
    path: '/academic-calendar',
    name: 'academic-calendar',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/calendar/calendar.vue')
    },
  },
  {
    path: '/academic-exam-list',
    name: 'academic-exam-list',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/examList.vue')
    },
  },
  {
    path: '/academic-exam',
    name: 'academic-exam',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/exam.vue')
    },
  },
  {
    path: '/academic-create-exam',
    name: 'academic-create-exam',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/createExam.vue')
    },
  },
  {
    path: '/academic-edit-exam/:id',
    name: 'academic-edit-exam',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/editExam.vue')
    },
  },
  {
    path: '/academic-exam-detail-student/:id',
    name: 'academic-exam-detail-student',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/examDetailStudent.vue')
    },
  },
  {
    path: '/academic-exam-detail-teacher/:id',
    name: 'academic-exam-detail-teacher',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/exam/examDetailTeacher.vue')
    },
  },
  {
    path: '/academic-evaluation',
    name: 'academic-evaluation',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/evaluation/evaluation.vue')
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore()

      if (!store.state.auth.profileData) {
        await store.dispatch('auth/getProfile')
      }
      const role = store.state.auth.profileData?.role
      if (role !== 'teacher') {
        next('/academic-evaluation-view')
      } else {
        next()
      }
    }
  },
  {
    path: '/academic-evaluation-view',
    name: 'academic-evaluation-view',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/evaluation/evaluation-view.vue')
    },
  },
  {
    path: '/academic-evaluation-detail',
    name: 'academic-evaluation-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/evaluation/evaluation-detail.vue')
    },
  },
  {
    path: '/academic-evaluation-create',
    name: 'academic-evaluation-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/evaluation/evaluation-create.vue')
    },
  },
  {
    path: '/academic-evaluation-edit',
    name: 'academic-evaluation-edit',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/academic/evaluation/evaluation-edit.vue')
    },
  },
  {
    path: '/payment-finance',
    name: 'payment-finance',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/finance/payment/payment.vue')
    },
  },
  {
    path: '/cart-payment-finance',
    name: 'cart-payment-finance',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/finance/payment/cart.vue')
    },
  },
  {
    path: '/history-payment-finance',
    name: 'history-payment-finance',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/finance/payment/history.vue')
    },
  },
  {
    path: '/saving-finance',
    name: 'saving-finance',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/finance/saving/saving.vue')
    },
  },
  {
    path: '/summary-finance',
    name: 'summary-finance',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/finance/summary/summary.vue')
    },
  },
  {
    path: '/offline',
    name: 'offline',
    component: function () {
      return import('@/views/networkError.vue')
    },
  },
  {
    path: '/server-error',
    name: 'server-error',
    component: function () {
      return import('@/views/serverError.vue')
    }
  },
  {
    path: '/journal',
    name: 'journal',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/journal.vue')
    },
  },
  {
    path: '/sos',
    name: 'sos',
    component: function () {
      return import('@/views/complaint/sos/sos.vue')
    }
  },
  {
    path: '/sos-history',
    name: 'sos-history',
    component: function () {
      return import('@/views/complaint/sos/sosHistory.vue')
    }
  },
  {
    path: '/sos-detail/:id',
    name: 'sos-detail',
    component: function () {
      return import('@/views/complaint/sos/sosDetail.vue')
    }
  },
  {
    path: '/laporin',
    name: 'laporin',
    component: function () {
      return import('@/views/complaint/laporin/laporin.vue')
    }
  },
  {
    path: '/laporin-detail/:id',
    name: 'laporin-detail',
    component: function () {
      return import('@/views/complaint/laporin/laporinDetail.vue')
    }
  },
  {
    path: '/laporin-create',
    name: 'laporin-create',
    component: function () {
      return import('@/views/complaint/laporin/laporinCreate.vue')
    }
  },
  {
    path: '/erapor',
    name: 'erapor',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/erapor.vue')
    },
  },
  {
    path: '/guest-book',
    name: 'guest-book',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/guestBook/guestBook.vue')
    },
  },
  {
    path: '/add-guest',
    name: 'add-guest',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/guestBook/guestForm.vue')
    },
  },
  {
    path: '/news-list',
    name: 'news-list',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/news/news-list.vue')
    },
  },
  {
    path: '/news-detail',
    name: 'news-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/news/news-detail.vue')
    },
  },
  {
    path: '/religions-tilawah',
    name: 'religions-tilawah',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/tilawahList.vue')
    },
  },
  {
    path: '/religions-tilawah-create',
    name: 'religions-tilawah-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/addTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-update/:id',
    name: 'religions-tilawah-update',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/editTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-detail/:id',
    name: 'religions-tilawah-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/detailTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-evaluation-setting/:id',
    name: 'religions-tilawah-evaluation-setting',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/evaluationTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-evaluation-add',
    name: 'religions-tilawah-evaluation-add',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/addEvaluationTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-detail-student/:id',
    name: 'religions-tilawah-detail-student',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/detailStudentTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-detail-student-create',
    name: 'religions-tilawah-detail-student-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/addStudentTilawah.vue')
    },
  },
  {
    path: '/religions-tilawah-detail-student-update/:id',
    name: 'religions-tilawah-detail-student-update',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tilawah/editStudentTilawah.vue')
    },
  },
  {
    path: '/religions-tahfidz',
    name: 'religions-tahfidz',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/tahfidzList.vue')
    },
  },
  {
    path: '/religions-tahfidz-create',
    name: 'religions-tahfidz-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/addTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-update/:id',
    name: 'religions-tahfidz-update',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/editTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-detail/:id',
    name: 'religions-tahfidz-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/detailTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-evaluation-setting/:id',
    name: 'religions-tahfidz-evaluation-setting',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/evaluationTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-evaluation-add',
    name: 'religions-tahfidz-evaluation-add',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/addEvaluationTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-detail-student/:id',
    name: 'religions-tahfidz-detail-student',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/detailStudentTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-detail-student-create',
    name: 'religions-tahfidz-detail-student-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/addStudentTahfidz.vue')
    },
  },
  {
    path: '/religions-tahfidz-detail-student-update/:id',
    name: 'religions-tahfidz-detail-student-update',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/tahfidz/editStudentTahfidz.vue')
    },
  },
  {
    path: '/religions-erapor',
    name: 'religions-erapor',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/erapor/listStudentErapor.vue')
    },
    beforeEnter: async (to, from, next) => {
      const store = useStore()

      if (!store.state.auth.profileData) {
        await store.dispatch('auth/getProfile')
      }
      const role = store.state.auth.profileData?.role
      if (role !== 'teacher' && role !== 'partner') {
        next('/religions-erapor-detail')
      } else {
        next()
      }
    }
  },
  {
    path: '/religions-erapor-detail',
    name: 'religions-erapor-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/religions/erapor/detailStudentErapor.vue')
    },
  },
  {
    path: '/student-bill',
    name: 'student-bill',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/schoolAdmin/studentBillsList.vue')
    },
  },
  {
    path: '/student-bill-create',
    name: 'student-bill-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/schoolAdmin/studentBillsCreate.vue')
    },
  },
  {
    path: '/teacher-attendance-daily',
    name: 'teacher-attendance-daily',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/daily/attendanceDaily.vue')
    },
  },
  {
    path: '/teacher-attendance-daily/summary',
    name: 'teacher-attendance-daily-summary',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/daily/attendanceDailySummary.vue')
    },
  },
  {
    path: '/teacher-attendance-daily/permission',
    name: 'teacher-attendance-daily-permission',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/daily/attendanceDailyPermission.vue')
    },
  },
  {
    path: '/teacher-attendance-daily/permission-list',
    name: 'teacher-attendance-daily-permission-list',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/daily/attendanceDailyPermissionList.vue')
    },
  },
  {
    path: '/teacher-attendance-monitor',
    name: 'teacher-attendance-monitor',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/monitor/attendanceMonitor.vue')
    },
  },
  {
    path: '/teacher-attendance-monitor/detail',
    name: 'teacher-attendance-monitor-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/monitor/attendanceMonitorDetail.vue')
    },
  },
  {
    path: '/teacher-journal',
    name: 'teacher-journal-list',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournalList.vue')
    },
  },
  {
    path: '/teacher-journal/:id',
    name: 'teacher-journal',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournal.vue')
    },
  },
  {
    path: '/teacher-journal-detail/:id',
    name: 'teacher-journal-detail',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournalDetail.vue')
    },
  },
  {
    path: '/teacher-journal/create',
    name: 'teacher-journal-create',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournalCreate.vue')
    },
  },
  {
    path: '/teacher-journal/edit',
    name: 'teacher-journal-edit',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournalEdit.vue')
    },
  },
  {
    path: '/teacher-journal/init',
    name: 'teacher-journal-init',
    meta: {
      isAuthorized: true
    },
    component: function () {
      return import('@/views/home/teacherAttendance/journal/teacherJournalInit.vue')
    },
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  // const store = useStore()
  const isOnline = store.state.network.isOnline

  if (!isOnline && to.name !== 'offline') {
    return next({
      name: 'offline',
      query: { redirect: to.fullPath },
    })
  } else if (isOnline && to.name === 'offline') {
    const redirectPath = to.query.redirect || '/home'
    return next(redirectPath)
  }

  store.dispatch('setDomain')
  let preferences = JSON.parse(window.localStorage.getItem('preferences'))
  if (Object.keys(to.meta).length === 0) {
    return next()
  } else {
    if (to.meta.isAuthenticated) {
      if (preferences) {
        let isAuth = false
        preferences.schools?.forEach((school) => {
          if (school?.isActive && school?.users?.length > 0) {
            //console.log('ada sekolah aktif')
            school.users.forEach((user) => {
              if (user.isActive) {
                //console.log('ada user aktif')
                if (user.auth) {
                  isAuth = true
                } else {
                  isAuth = false
                }
              }
            })
          }
        })

        if (isAuth) {
          return next({ path: '/home' })
        } else if (preferences.is_intro) {
          return next({ path: '/intro' })
        } else {
          return next({ path: '/login' })
        }
      } else {
        localStorage.setItem("preferences", JSON.stringify({ is_intro: true }))
        return next({ path: '/intro' })
      }
    }

    if (to.meta.isAuthorized) {
      if (preferences) {

        let isAuth = false
        preferences.schools.forEach((school) => {
          if (school?.isActive && school?.users?.length > 0) {
            //console.log('ada sekolah aktif')
            school.users.forEach((user) => {
              if (user.isActive) {
                //console.log('ada user aktif')
                if (user.auth) {
                  isAuth = true
                } else {
                  isAuth = false
                }
              }
            })
          }
        })

        //console.log('isAuth = ', isAuth)

        if (isAuth) {
          return next()
        } else {
          return next({ path: '/login' })
        }
      } else {
        return next({ path: '/' })
      }
    }
  }
})

export default router
